exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p{\n    margin-left: 4em;\n    margin-right: 4em;\n    line-height: 30px;\n    font-family: Arial,Helvetica,sans-serif;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/news/news-details/news-details.component.css
// module id = 900
// module chunks = 0